import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
const NAMES = ['Luciana Russo', 'Hernán Bianchi', 'Valentina Ferraro', 'Martín Romano', 'Sofía Esposito', 'Facundo Conti', 'Camila Greco', 'Diego Martínez', 'Julieta González', 'Lucas Fernández', 'Micaela Rodríguez', 'Mateo Silva', 'Agustina López', 'Tomás Gómez', 'Carolina Pérez', 'Nicolás Rossi', 'Florencia Colombo', 'Joaquín Ricci', 'Paula Marino', 'Santiago Bruno'];
const CITIES = ['CABA', 'La Plata, BA', 'Rosario, SF', 'Córdoba Capital', 'Mendoza', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Bariloche, RN', 'Neuquén', 'Santa Fe', 'Posadas', 'Resistencia', 'Bahía Blanca', 'San Juan', 'La Rioja', 'Paraná, ER', 'Comodoro Rivadavia'];
const PRODUCTS = ['Sistema Esencial', 'Pack PRO Completo'];
export const PurchaseToast = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    product: '',
    timeAgo: 0
  });
  const generatePurchase = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    // 60% chance for PRO
    const product = Math.random() > 0.4 ? PRODUCTS[1] : PRODUCTS[0];
    const timeAgo = Math.floor(Math.random() * 14) + 1;
    setPurchaseData({
      name,
      city,
      product,
      timeAgo
    });
    setIsVisible(true);
  };
  useEffect(() => {
    // Initial popup after 8 seconds
    const initialTimer = setTimeout(() => {
      generatePurchase();
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    let hideTimer: NodeJS.Timeout;
    let nextShowTimer: NodeJS.Timeout;
    if (isVisible) {
      // Auto hide after 6 seconds
      hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    } else if (purchaseData.name !== '') {
      // Schedule next appearance (40-60 seconds)
      const nextInterval = Math.floor(Math.random() * 20000) + 40000;
      nextShowTimer = setTimeout(() => {
        generatePurchase();
      }, nextInterval);
    }
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextShowTimer);
    };
  }, [isVisible, purchaseData.name]);
  return <AnimatePresence data-id="element-301">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-6 left-4 md:left-6 z-50 w-[calc(100%-2rem)] md:w-80 bg-gris-oscuro border border-gris-medio border-l-4 border-l-cyan rounded-xl shadow-2xl p-4 pr-10" data-id="element-302">
          <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-gris-claro hover:text-blanco transition-colors" aria-label="Cerrar notificación" data-id="element-303">
            <XIcon size={16} data-id="element-304" />
          </button>

          <div className="flex items-start gap-3" data-id="element-305">
            <div className="mt-1 relative" data-id="element-306">
              <BadgeCheckIcon className="text-verde" size={20} data-id="element-307" />
              <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-verde rounded-full animate-ping opacity-75" data-id="element-308"></span>
              <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-verde rounded-full" data-id="element-309"></span>
            </div>
            <div data-id="element-310">
              <p className="text-xs font-semibold text-verde uppercase tracking-wider mb-1" data-id="element-311">
                Compra verificada
              </p>
              <p className="text-[13px] text-blanco leading-snug" data-id="element-312">
                <span className="font-bold" data-id="element-313">{purchaseData.name}</span> de{' '}
                {purchaseData.city} acaba de comprar el{' '}
                <span className="text-cyan font-semibold" data-id="element-314">
                  {purchaseData.product}
                </span>
              </p>
              <p className="text-[11px] text-gris-claro mt-1.5" data-id="element-315">
                hace {purchaseData.timeAgo} min
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};